import { useState } from "react";
import { Carousel } from "react-bootstrap";
import { ChevronLeft, ChevronRight } from "lucide-react";
import slide2 from '../../assets/images/02-Gammadda.png';
import slide3 from '../../assets/images/gammadda-01.png';
import slide4 from '../../assets/images/gammadda-03.png';
import './heroslider.css';





const slides = [
  
 
  
  {
    title: "When disaster struck, lives were turned upside down",
    subtitle: "",
    description: "",
    image: slide3,
  },
   {
    title: "Sri Lankans came together as one. ",
    subtitle: "",
    description: "Listening to the people, creating lasting solutions",
    image: slide2,
  },
  {
    title: "Relief delivered. Hope restored",
    subtitle: "",
    description: "",
    image: slide4,
  },
  {
    title: "ALONE, SO LITTLE. TOGETHER, SO MUCH…",
    subtitle: "",
    description: "",
    image:
      "https://gammadda.lk/static/media/WEB-COVER.b308df0dff74731d3af8.jpg",
  },

];

const HeroSlider = ({ lang = "en" }) => {
  const headingStyle = {
    fontSize: lang === "si" ? "70px" : lang === "ta" ? "55px" : "80px",
  };

  const subHeadingStyle = {
    fontSize: lang === "si" ? "50px" : lang === "ta" ? "40px" : "60px",
  };

  return (
    <div 
      className="main-carouel" 
      style={{ height: "93vh", overflow: "hidden",position: "relative",top:"65px" }}>
      <Carousel
        interval={5000}
        fade
        indicators={true}
        prevIcon={<ChevronLeft size={40} color="#fff" />}
        nextIcon={<ChevronRight size={40} color="#fff" />}
      >
        {slides.map((slide, index) => (
          <Carousel.Item key={index}>
            {/* Background */}
            <div 
              className="hero-slide-background"
              style={{
                height: "85vh",
                backgroundImage: `url(${slide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
              }}
            >
              {/* Dark overlay */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0.4))",
                }}
              ></div>

              {/* Text */}
              <div
                className="d-flex flex-column justify-content-center align-items-center text-center h-100 px-3"
                style={{ position: "relative", zIndex: 2 }}
              >
                <h1 
                  className="hero-title"
                  style={{
                    ...headingStyle,
                    fontWeight: "bold",
                    color: "white",
                    transition: "0.7s",
                  }}
                >
                  {slide.title}
                </h1>

                <h2
                  style={{
                    ...subHeadingStyle,
                    fontWeight: "600",
                    color: "white",
                    marginTop: "10px",
                    transition: "0.7s",
                  }}
                >
                  {slide.subtitle}
                </h2>

                {/* <p
                  style={{
                    fontSize: "24px",
                    color: "#ddd",
                    marginTop: "20px",
                    maxWidth: "800px",
                    transition: "0.7s",
                  }}
                >
                  {slide.description}
                </p> */}

                {/* <div
                  style={{
                    width: "100px",
                    height: "3px",
                    backgroundColor: "white",
                    marginTop: "20px",
                  }}
                /> */}
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default HeroSlider;
